import { useEffect, useState } from "react"

/** The app bar and the two in-flow banner slots — what a top-anchored overlay must not cover. */
const TOP_CHROME = [
  '[data-ui="UI-SL2W-001"]',
  '[data-ui="UI-SL2W-282"]',
  '[data-ui="UI-SL2W-283"]',
].join(",")

const GAP_PX = 16

/** Lowest on-screen bottom edge of the top chrome, plus a gap. `GAP_PX` when none is on screen (embedded / RxPro). */
export function measureOverlayTop(root: ParentNode = document): number {
  let bottom = 0
  root.querySelectorAll(TOP_CHROME).forEach((el) => {
    const r = el.getBoundingClientRect()
    if (r.height > 0 && r.bottom > bottom) bottom = r.bottom
  })
  return Math.round(bottom) + GAP_PX
}

/**
 * Top offset for the panel and the top-corner toasts (LOCKER-483 F1.1): below the app bar AND
 * the in-flow `top` / `below-header` banners, so a floating message never covers a banner or its
 * action. Re-measured when `key` (the visible banners) changes, on resize, and on any scroll.
 */
export function useOverlayTop(enabled: boolean, key: string): number {
  const [top, setTop] = useState(GAP_PX)
  useEffect(() => {
    if (!enabled) return
    let frame = 0
    const update = () => {
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() => setTop(measureOverlayTop()))
    }
    setTop(measureOverlayTop())
    window.addEventListener("resize", update)
    window.addEventListener("scroll", update, true)
    return () => {
      cancelAnimationFrame(frame)
      window.removeEventListener("resize", update)
      window.removeEventListener("scroll", update, true)
    }
  }, [enabled, key])
  return top
}
